import { playStoreLink, appStoreLink, playStoreTMobileLink, appStoreTMobileLink, applinksInvitesEeroLink,
    applinksInvitesE2roLink, applinksInvitesEeroTMobileLink, applinksInvitesE2roTMobileLink, applinksMyNewE2roLink,
    applinksMyNewEeroLink, applinksMyNewEeroTMobileLink, applinksMyNewE2roTMobileLink, applinksAppLink, applinksAppE2roLink,
    applinksAppTMobileLink, applinksAppE2roTMobileLink, applinksAddOrReplaceDeviceLink,
    applinksAddOrReplaceDeviceE2roLink, applinksAddOrReplaceDeviceTMobileLink, applinksAddOrReplaceDeviceE2roTMobileLink,
    applinksKilimanjaroLink, applinksKilimanjaroE2roLink, applinksKilimanjaroTMobileLink,
    applinksKilimanjaroE2roTMobileLink, applinksPlusPurchaseCompleteLink, applinksPlusPurchaseCompleteE2roLink,
    applinksSubscriptionReferralLink, applinksSubscriptionReferralE2roLink } from '../../../utils/urls';

interface AppOptions {
    isDesktop: boolean;
    downloadLink: string;
    openLink: string;
}

enum AppType {
    Invites,
    MyNewEero,
    App,
    AddOrReplaceDevice,
    Kilimanjaro,
    PlusPurchaseComplete,
    SubscriptionReferral,
    TMobileInvites,
    TMobileMyNewEero,
    TMobileApp,
    TMobileAddOrReplaceDevice,
    TMobileKilimanjaro
}

function getAppOptions(app: AppType): AppOptions {
    let isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod');
    let isAndroid = navigator.userAgent.match('Android');

    let storeLink = isAndroid ? playStoreLink : appStoreLink;
    let currentUrl = window.location.toString();
    let baseDomain = "";

    switch (app) {
        case AppType.Invites: 
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksInvitesE2roLink : applinksInvitesEeroLink;
            break;
        case AppType.MyNewEero:
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksMyNewE2roLink : applinksMyNewEeroLink;
            break;
        case AppType.App: 
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksAppE2roLink : applinksAppLink;
            break;
        case AppType.AddOrReplaceDevice: 
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksAddOrReplaceDeviceE2roLink : applinksAddOrReplaceDeviceLink;
            break;
        case AppType.Kilimanjaro: 
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksKilimanjaroE2roLink : applinksKilimanjaroLink;
            break;
        case AppType.PlusPurchaseComplete: 
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksPlusPurchaseCompleteE2roLink : applinksPlusPurchaseCompleteLink;
            break;
        case AppType.SubscriptionReferral: 
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksSubscriptionReferralE2roLink : applinksSubscriptionReferralLink;
            break;
        case AppType.TMobileInvites:
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksInvitesE2roTMobileLink : applinksInvitesEeroTMobileLink;
            storeLink = isAndroid ? playStoreTMobileLink : appStoreTMobileLink;
            break;
        case AppType.TMobileMyNewEero:
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksMyNewE2roTMobileLink : applinksMyNewEeroTMobileLink;
            storeLink = isAndroid ? playStoreTMobileLink : appStoreTMobileLink;
            break;
        case AppType.TMobileApp:
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksAppE2roTMobileLink : applinksAppTMobileLink;
            storeLink = isAndroid ? playStoreTMobileLink : appStoreTMobileLink;
            break;
        case AppType.TMobileAddOrReplaceDevice:
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksAddOrReplaceDeviceE2roTMobileLink : applinksAddOrReplaceDeviceTMobileLink;
            storeLink = isAndroid ? playStoreTMobileLink : appStoreTMobileLink;
            break;
        case AppType.TMobileKilimanjaro:
            baseDomain = currentUrl.includes("applinks.eero.com") ? applinksKilimanjaroE2roTMobileLink : applinksKilimanjaroTMobileLink;
            storeLink = isAndroid ? playStoreTMobileLink : appStoreTMobileLink;
            break;
    }

    let customUrl = baseDomain + window.location.search;

    if (isiOS || isAndroid) {
        // display mobile stuff
        return {
            isDesktop: false,
            downloadLink: storeLink,
            openLink: customUrl
        }
    } else {
        // display desktop stuff
        return {
            isDesktop: true,
            downloadLink: "",
            openLink: ""
        }
    }
}

export {
    getAppOptions,
    AppType
}
